<script setup>
import { defineProps, ref, defineExpose } from "vue";
import Email from "@/components/form-fields/email/Index.vue";
import FirstName from "@/components/form-fields/first-name/Index.vue";
import LastName from "@/components/form-fields/last-name/Index.vue";
import PrivacyPolicy from "@/components/form-policy/privacy-policy/Index.vue";
import {
	useCsrFormValidator,
} from "@/hooks/common/useCsrFormValidator";

import { usePostUserinfo } from "@/hooks/api/useISCRMEdm";
import { useBrand, useUcFirst } from "@/hooks/common/useUtils";

import { toggleZIndexToNormal } from "@/hooks/common/useZIndex";

const props = defineProps({
	product: {
		type: Object,
		default: () => {
			return {};
		}
	},
	config: {
		type: Object,
		default: () => {
			return {};
		},
	}
});

const visible = ref(false);
const esbformfields = ref([]);

const { emailFields = []} = props?.config ?? {};

esbformfields.value = emailFields;

const open = () => {
	toggleZIndexToNormal();
	visible.value = true;
};

const cancel = () => {
	toggleZIndexToNormal(false);
	visible.value = false;
};

const emailInput = ref(null);
const firstNameInput = ref(null);
const lastNameInput = ref(null);
const privacyPolicy = ref(null);

let isSubmitting = false;
const submitForm = async () => {
	const {originalSite, language } = document.body.dataset || {};
	useCsrFormValidator([emailInput, firstNameInput, lastNameInput, privacyPolicy]).then(async (res) => {
		const { productName, productModelNumber } = props?.product ?? {};
		if (isSubmitting) { return; }
		isSubmitting = true;
		try {
			const { error } = await usePostUserinfo({
				...res,
				country: originalSite?.toUpperCase(),
				language,
				entrance: "PES",
				productName: productName,
				modelNumber: productModelNumber,
				brand: useUcFirst(useBrand()),
				consentForPrivacyPolicy: "Y",
			});

			isSubmitting = false;
			if (error.value) {
				// useFailMsgBox(error.value);
			} else {
				window.igws.$toast.open({
					status: "success",
					text: props?.config?.subscribeSuccessfullyPrompt || "Subscribe success",
				});
				cancel();
			}
		} catch (err) {
			isSubmitting = false;
		}
	});
	
};

defineExpose({
	open,
});
</script>

<template>
	<MdDialog
		:title="config.emailTitle"
		:visible="visible"
		@close="cancel"
		class="csr-esb-dialog csr-md-dialog-v2"
		append-to-body
	>
		<div :class="{'form-v3-ecommerce': true, 'form-v3': true,'is-three-fields': emailFields.length === 3}">
			<Email
				v-if="emailFields.indexOf('email') !== -1"
				class="csr-esb-dialog__item"
				ref="emailInput"
				:data-conf="{ label: config.emailAddressLabel, placeholder: config.emailAddressLabel, required: true,name:'email', defErrorMsg: config.requiredFieldsPrompt, formatHint: config.incorrectEmailFormatPrompt}" />
			<FirstName
				v-if="emailFields.indexOf('firstName') !== -1"
				ref="firstNameInput"
				class="csr-esb-dialog__item"
				:data-conf="{ label: config.firstNameLabel, placeholder: config.firstNameLabel, name: 'firstName'}" />
			<LastName
				v-if="emailFields.indexOf('lastName') !== -1"
				ref="lastNameInput"
				class="csr-esb-dialog__item"
				:data-conf="{ label: config.lastNameLabel, placeholder: config.lastNameLabel, name: 'lastName'}" />
			<PrivacyPolicy
				ref="privacyPolicy"
				class="csr-form__privacy_policy"
				:data-conf="{label: config.agreementLabel, required: true,}" />
			<div class="esb-form-actions">
				<button class="md-button-v2 md-button md-button--primary md-button--L" @click="submitForm">{{ config.submitButtonLabel }}</button>  
			</div>
		</div>
	</MdDialog>
</template>
